import React, { createContext, useContext, useState, useEffect } from 'react';

const PermissionsContext = createContext();

const defaultPermissions = {
  userPermissions: [],
  fetchUserPermissions: () => { }
};

export const PermissionsProvider = ({ children, initialPermissions }) => {
  const [userPermissions, setUserPermissions] = useState(initialPermissions || defaultPermissions.userPermissions);

  const fetchUserPermissions = () => {
    const permissionsFromStorage = JSON.parse(localStorage.getItem('user_permissions'));
    const permissions = Array.isArray(permissionsFromStorage?.data) ? permissionsFromStorage.data : initialPermissions || [];
    setUserPermissions(permissions);
  };

  useEffect(() => {
    fetchUserPermissions();
  }, []);

  return (
    <PermissionsContext.Provider value={{ userPermissions, fetchUserPermissions }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  const { userPermissions, fetchUserPermissions } = useContext(PermissionsContext);
  useEffect(() => {
    fetchUserPermissions();
  }, []);
  return userPermissions || [];
};